export default "__VITE_ASSET__1tCE6Ai___"